import * as React from 'react';
export const qrisSvg = React.forwardRef(function qrisSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#A10C0E',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.46 12.623h6.812v4.094h-2.868l2.868 2.623h-2.434l-2.793-2.623v2.623H11.46v-4.151h5v-1h-5v-1.566Zm7.51 6.717h1.66v-6.717h-1.66v6.717ZM5.736 18.094V13H4.434a.403.403 0 0 0-.415.396c0 1.208-.019 4.736-.019 5.906 0 .226.189.415.396.415h3.868v-1.623H5.736ZM9.045 21h1.698v-3.358H9.045V21ZM6.48 12.623v1.679h2.565v2.51h1.698v-3.774c0-.227-.188-.396-.396-.415H6.48Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.48 15.113v1.698h1.697v-1.698H6.48Zm1.188 1.189H6.97v-.68h.698v.68Zm21.151 1.34v2.509a.403.403 0 0 1-.415.396h-2.547v.415h2.98c.208 0 .397-.17.397-.396v-2.924h-.415ZM3.215 14.283v-2.49c0-.227.17-.378.396-.378h2.547c.02 0 .02-.019.02-.019v-.377s0-.019-.02-.019H3.215a.403.403 0 0 0-.415.396v2.887c0 .019.019.019.019.019l.396-.019c0 .019-.019.019 0 0Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M28.083 14.283v-1.66h-6.736v4.17h4.49v.83h-4.49v1.679h6.736v-4.17h-4.472v-.849h4.472Z',
      fill: '#fff',
    }),
  );
});
qrisSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var qris = {
  category: 'brand',
  colorable: false,
  name: 'qris',
  svg: qrisSvg,
};
